import { render, staticRenderFns } from "./CheckCustomerRisk.vue?vue&type=template&id=351aeccf&scoped=true&"
import script from "./CheckCustomerRisk.vue?vue&type=script&lang=js&"
export * from "./CheckCustomerRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351aeccf",
  null
  
)

export default component.exports